import React, { useState } from 'react'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import ViewportEnter from 'components/motion/ViewportEnter'
import TransitionLink, { TransitionState } from 'gatsby-plugin-transition-link'
import { PrismicLink } from 'prismic'

import { BodyCopy } from 'components/ui/Typography'
import WorkThumbnail from 'components/ui/WorkThumbnail'

import s from './RelatedCaseStudies.module.scss'
const cn = classNames.bind(s)

const _ = {
  max: 4,
  exitLength: 1.5,
  exitDelay: 0, // before unmounting
  entryLength: 2, // duration of "entering" class before switching to "entered"
  entryDelay: 1.5, // before mounting new page
}

const RelatedCaseStudies = ({ data }) => {
  const [inView, setInView] = useState(false)

  return (
    <TransitionState>
      {({ mount, transitionStatus, current } = {}) => {
        return (
          <ViewportEnter onEnter={() => setInView(true)}>
            <div className={cn('wrapper')}>
              {data.slice(0, _.max).map((item, index) => (
                <article className={cn('project')} key={index}>
                  <TransitionLink
                    className={cn('link')}
                    to={PrismicLink.url(item?.project)}
                    exit={{
                      length: 2,
                      state: { to: 'PROJECT_PAGE' },
                    }}
                    entry={{
                      delay: 2, // before mounting new page
                    }}
                    aria-label="project"
                  >
                    <WorkThumbnail
                      portraitImage={item.project?.portrait_image?.url || null}
                      portraitVideoMP4={item.project?.portrait_video_mp4 || null}
                      portraitVideoWEBM={item.project?.portrait_video_webm || null}
                      landscapeImage={item.project?.landscape_image?.url || null}
                      view={{
                        inView: inView,
                        transitionStatus: transitionStatus,
                        transitioningTo: current.state.to || '',
                      }}
                      delay={index * 0.1 + 's'}
                    />
                    <div className={s.thumbnailCover} />
                    <div className={cn('title', transitionStatus)}>
                      <BodyCopy as="h3">{item.project?.title[0]?.text}</BodyCopy>
                    </div>
                  </TransitionLink>
                </article>
              ))}
            </div>
          </ViewportEnter>
        )
      }}
    </TransitionState>
  )
}

RelatedCaseStudies.propTypes = {
  data: PropTypes.array,
}

export default RelatedCaseStudies
